<template>
	<LoginLayout
		heading="SSO Required"
		secondary-text="Single Sign-On is enabled for this domain"
	>
		<template #form>
			<div class="text-center">
				<div class="login-icon-roundel mb-6">
					<v-icon size="32">
						mdi-shield-key-outline
					</v-icon>
				</div>
			</div>
			<Message>
				Please log in using your 'Single Sign On' details
			</Message>
			<a @click="$router.push({ path: '/' })">
				Please click here to return to the login screen.
			</a>
		</template>
	</LoginLayout>
</template>
<script>
import LoginLayout from '../layouts/login-layout.vue'
import Message from './message.vue'
export default {
	components: { Message, LoginLayout }
}
</script>
